module.exports = __webpack_public_path__ + "img/profile-woman-8-min.079a0a01.jpg";